import React, {useState, useEffect} from 'react';
import {Spinner} from 'reactstrap';

export const ModalGenerarInformes = (props) => {
	/* Destructuring the props object. */
	const {setEstadoModal} = props;

	/* A React Hook. It is a way to manage state in React. */
	const [EstadoModalInterno, setEstadoModalInterno] = useState(0);

	/**
	 * It sets the state of the modal to 0.
	 */
	const volver = () => {
		setEstadoModal(0);
	};
	/**
	 * It activates the service.
	 */
	async function activarServicio() {
		setEstadoModalInterno(0);
		try {
			let ss = await fetch('https://www.youtube.com/');
		} catch (e) {
			console.error('error envio datos [enviarPresupuesto]');
		}
		setEstadoModalInterno(1);
	}

	/**
	 * It returns the function volver()
	 */
	const descargarInforme = () => {
		volver();
	};

	/* A React Hook. It is a way to manage state in React. */
	useEffect(() => {
		activarServicio();
	}, []);

	return (
		<div className='modalBaseFondoGD'>
			{EstadoModalInterno === 0 ? (
				<div className='modalBaseGD'>
					<div>
						<Spinner />
					</div>
				</div>
			) : EstadoModalInterno === 1 ? (
				<div className='modalBaseGD'>
					<div>Informe generado con exito !</div>
					<div className='botonesGenerarInforme'>
						<div
							className='button'
							onClick={() => volver()}
						>
							<b>Volver</b>
						</div>
						<div
							className='button'
							onClick={() => descargarInforme()}
						>
							<b>Descargar informe</b>
						</div>
					</div>
				</div>
			) : (
				<div className='modalBaseGD'>
					<div>El informe no pudo generarse</div>
					<div className='botonesGenerarInforme'>
						<div
							className='button'
							onClick={() => activarServicio()}
						>
							<b>Volver a intentar</b>
						</div>
						<div
							className='button'
							onClick={() => volver()}
						>
							<b>Salir</b>
						</div>
					</div>
				</div>
			)}
		</div>
	);
};
